import {Api} from "laravel-request";
import moment from 'moment';

const useTaskActions = (
    id: string | null,
    comment: string,
    startDate: any,
    endDate: any,
    typeId: any,
    contacts: any[],
    contactId: string,
    repeatId: any,
    closeForm: () => void,
    callback: (data: any) => void,
    changeFormErrors: (errors: any) => void,
    setId: (id: any) => void,
    loading: boolean,
    setLoading: (loading: boolean) => void
) => {

    const handleDelete = () => {
        if (loading) return;
        setLoading(true);
        Api.delete('crm-contact-task', 'destroy', id)
            .call(
                () => {
                    setLoading(false);
                    closeForm();
                    callback(null);
                },
                (xhr: any, responseData: any) => {
                    if (responseData?.meta?.errors) {
                        changeFormErrors(responseData?.meta?.errors);
                    }
                    setLoading(false);
                }
            );
    };

    const prepareData = () => {
        let clearUserId = '';
        let clearContactId = '';

        const contactIndex = contacts.findIndex((row) => row.id === contactId);
        if (contactIndex !== -1) {
            const contact = contacts[contactIndex];
            switch (contact.innerType) {
                case 'user':
                    clearUserId = contact.clearId;
                    break;
                case 'contact':
                    clearContactId = contact.clearId;
                    break;
            }
        }

        const startForSend = moment(startDate);
        const endForSend = moment(endDate);

        return {
            comment: comment,
            start_at: startForSend && startForSend.isValid() ? startForSend.format('YYYY-MM-DD HH:mm:ss') : null,
            end_at: endForSend && endForSend.isValid() ? endForSend.format('YYYY-MM-DD HH:mm:ss') : null,
            type_id: typeId,
            user_id: clearUserId,
            contact_id: clearContactId,
            repeat_id: repeatId,
        };
    };

    const handleUpdate = () => {
        setLoading(true);
        const data = prepareData();
        (data as { id?: number | string | null }).id = id ?? undefined;

        Api.putArg('crm-contact-task', 'update', id, data)
            .call(
                (response) => {
                    closeForm()
                    callback(response);
                    changeFormErrors({});
                    setLoading(false);
                },
                (xhr: any, responseData: any) => {
                    if (responseData?.meta?.errors) {
                        changeFormErrors(responseData?.meta?.errors);
                    }
                    setLoading(false);
                }
            );
    };

    const handleCreate = () => {
        setLoading(true);
        const data = prepareData();

        Api.post('crm-contact-task', 'store', data)
            .call(
                (response) => {
                    closeForm();
                    setId(response.meta.id);
                    callback(response);
                    changeFormErrors({});
                    setLoading(false);
                },
                (xhr: any, responseData: any) => {
                    if (responseData?.meta?.errors) {
                        changeFormErrors(responseData?.meta?.errors);
                    }
                    setLoading(false);
                }
            );
    };

    return { handleDelete, handleUpdate, handleCreate };
};

export default useTaskActions;